export const getBoostingRequestId = (order) =>
  order?.metadata?.boosting_request_id || order?.boosting_request_id || null;

export const isBoostingOrder = (order) =>
  Boolean(getBoostingRequestId(order) || order?.metadata?.type === 'boosting');

export const getOrderHref = (order) => {
  const requestId = getBoostingRequestId(order);
  if (requestId) return `/boosting/requests/${requestId}`;
  if (order?.metadata?.type === 'boosting') return '/profile/boosting/my-requests';
  return order?.id ? `/orders/${order.id}` : null;
};
